import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { InputIrmao } from '../../common/types/Irmao'
import { obrigatorio } from '../shareds/regras'
import { revalidarPalavra } from '@/services/AuthService'
import { alert, authModule } from '@/store'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'RevalidacaoDePalavra',
  props: {
	usuario: { type: Object as PropType<Pick<InputIrmao, 'nomeCompleto' | 'cim'>> },
},
  setup(__props) {



const router = useRouter()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const carregando = ref(false)
const verPalavra = ref(false)
const palavra = ref('')

async function revalidarPalavraSemestral() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		const { data } = await revalidarPalavra({
			palavra: palavra.value,
		})
		await authModule.logarToken(data)
		router.push({ name: 'home' })

	} catch (error) {
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}

return { __sfc: true,router, form, carregando, verPalavra, palavra, revalidarPalavraSemestral, ContainerCenter, obrigatorio }
}

})